import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { AgGridReact } from "ag-grid-react";
import { useHistory } from "react-router-dom";
import { Alert, IconButton } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";

import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-balham.css";

import BtnCellRenderer from "../../common/BtnCellRenderer";
import { patientActions, roomMasterActions } from "../../../core/actions";

function RoomMasterGrid({ roommaster, onGridAction }) {
  const history = useHistory();
  const dispatch = useDispatch();

  const [serverRes, setServerRes] = useState({ success: "", error: "" });
  const [roomRowData, setRoomRowData] = useState({});
  const [roomRowList, setRoomRowList] = useState([]);
  const [confirm, setConfirm] = useState(false);

  const columnDefs = [
    { headerName: "Room Name", field: "roomName", flex: 1 },
    { headerName: "Room Code", field: "roomCode", flex: 1 },
    { headerName: "Room Category", field: "roomCategory", flex: 1 },
    { headerName: "Description", field: "description", flex: 1 },
    { headerName: "Type", field: "type", flex: 1 },
    { headerName: "Floor Id", field: "floorId", flex: 1 },
    { headerName: "Section", field: "section", flex: 1 },
    {
      headerName: "Actions",
      field: "Actions",
      flex: 1,
      width: 150,
      cellRenderer: "BtnCellRenderer",
    },
  ].map((col) => ({
    ...col,
    sortable: true,
    filter: true,
    resizable: true,
    floatingFilter: true,
    headerClass: "ag-header-left",
  }));

  // Load initial data
  useEffect(() => {
    dispatch(patientActions.setPageHeader("roomList"));
    if (roommaster?.length) setRoomRowList(roommaster);
  }, [roommaster, dispatch]);

  // Handle row actions
  const getAggriddata = (e) => {
    if (e.colDef.field === "Actions") {
      setConfirm(!confirm);
      setRoomRowData(e.data);
      handleSubmit(e.data);
    } else {
      history.push("/roommaster", { rowData: e.data });
    }
  };

  // Delete / toggle room status
  const handleSubmit = (row) => {
    dispatch(
      roomMasterActions.roomDelete(row, (resCb) => {
        if (!resCb) return;

        if (resCb.messageStrip.includes("already booked")) {
          setServerRes({ success: "", error: resCb.messageStrip });
        } else if (resCb.messageStrip.includes("can be made inactive")) {
          setServerRes({
            error: "",
            success: "Room status has been successfully changed",
          });
        }

        setTimeout(() => {
          onGridAction?.();
          setConfirm((prev) => !prev);
          closeAlert();
        }, 3000);
      })
    );
  };

  const closeAlert = () => setServerRes({ success: "", error: "" });

  return (
    <>
      {serverRes.error && (
        <Alert severity="error" className="alert-div">
          {serverRes.error}
          <IconButton size="small" onClick={closeAlert}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      {serverRes.success && (
        <Alert severity="success" className="alert-div">
          {serverRes.success}
          <IconButton size="small" onClick={closeAlert}>
            <CloseIcon fontSize="inherit" />
          </IconButton>
        </Alert>
      )}

      <div className="p-0 preview">
        <div
          className="ag-theme-balham ag-style card rounded table mb-0 tcol"
          style={{ height: 500, width: "98%" }}
        >
          <AgGridReact
            frameworkComponents={{ BtnCellRenderer }}
            pagination
            paginationPageSize={10}
            rowData={roomRowList}
            columnDefs={columnDefs}
            rowStyle={{ background: "white" }}
            onCellClicked={getAggriddata}
          />
        </div>
      </div>
    </>
  );
}

export default RoomMasterGrid;
